module.exports = __webpack_public_path__ + "media/newstyle/images/info1-b896433fa66c94315b6a2b09c338bd06.jpg";